import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios
import echarts from 'echarts'
import "echarts/map/js/china"

import url from './until/url'
Vue.prototype.$url = url
Vue.prototype.$echarts = echarts

new Vue({
  render: h => h(App)
}).$mount('#app')
